import styled, { css } from 'styled-components';

export const PageContainer = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    background: ${theme.colorBgContainer};
    transition: all ${theme.motionDurationMid} ${theme.motionEaseInOut};
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    min-height: 0;
  `}
`;

/* Note: Responsive design is handled by the parent Container component */

/* Utility class for content that needs to fill available space */
export const FullHeightContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

/* Utility class for scrollable content within the interactive layout */
export const ScrollableContent = styled.div`
  ${({ theme }) => css`
    flex: 1;
    overflow: auto;

    /* Custom scrollbar styling to match theme */
    &::-webkit-scrollbar {
      width: ${theme.sizeXS}px;
      height: ${theme.sizeXS}px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.colorFillQuaternary};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.colorFillSecondary};
      border-radius: ${theme.borderRadiusXS}px;

      &:hover {
        background: ${theme.colorFillContent};
      }
    }

    /* Firefox scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: ${theme.colorFillSecondary} ${theme.colorFillQuaternary};
  `}
`;
